"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
var React = require("react");
var DEFAULT_TIMEOUT = 750;
var SearchInput = /** @class */ (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput(props) {
        var _this = _super.call(this, props) || this;
        _this.timer = 0;
        _this.state = { filterText: '' };
        return _this;
    }
    SearchInput.prototype.reset = function () {
        this.setState({ filterText: '' });
        if (this.timer) {
            clearTimeout(this.timer);
        }
    };
    SearchInput.prototype.componentWillUnmount = function () {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    };
    SearchInput.prototype.search = function (filterText) {
        var _this = this;
        this.setState({ filterText: filterText });
        if (!this.timer) {
            window.setTimeout(function () {
                _this.props.onChange(_this.state.filterText);
                _this.timer = 0;
            }, this.props.timeOut || DEFAULT_TIMEOUT);
        }
    };
    SearchInput.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "search-input" },
            React.createElement("i", { className: "material-icons icon" }, "search"),
            React.createElement("input", { placeholder: "Zoeken", value: this.state.filterText, className: "search-input", type: "text", onChange: function (e) { return _this.search(e.target.value); } })));
    };
    return SearchInput;
}(React.Component));
exports.SearchInput = SearchInput;
